/** Placeholder while the invoiceable orders load. */
export default function CreateInvoiceModalSkeleton() {
  return (
    <div className="animate-pulse space-y-4" aria-busy="true">
      <div className="space-y-2">
        <div className="h-3 w-full rounded bg-zinc-200 dark:bg-zinc-700" />
        <div className="h-3 w-2/3 rounded bg-zinc-200 dark:bg-zinc-700" />
      </div>
      <div className="space-y-2">
        {[0, 1, 2].map((row) => (
          <div
            key={row}
            className="space-y-2 rounded-lg border border-zinc-200 px-3.5 py-3 dark:border-zinc-700"
          >
            <div className="h-3 w-1/3 rounded bg-zinc-200 dark:bg-zinc-700" />
            <div className="h-3 w-1/2 rounded bg-zinc-200 dark:bg-zinc-700" />
          </div>
        ))}
      </div>
      <div className="h-5 w-24 rounded bg-zinc-200 dark:bg-zinc-700" />
    </div>
  );
}
